import React, { use, useState } from 'react';

import { useHeaderPromoRibbonContent } from 'src/components/layout/redesign/club-header-desktop/use-header-promo-ribbon-content';
import HeaderMobile from 'src/components/layout/redesign/header-mobile';
import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import PromoRibbon from 'src/components/layout/redesign/header-shared/promo-ribbon';
import { ClubCmsContent } from 'src/content/club-content-consumer';
import { SiteContext } from 'src/context/site-context';
import { amplitudeLinkTrackEvent } from 'src/helpers/amplitude-event-track';
import { pathToTitle } from 'src/helpers/string-helper';

type ClubHeaderMobileProps = {
  disablePromoRibbon?: boolean;
  forcePromoRibbonVisible?: boolean;
  forceMobileHeader?: boolean;
};

const ClubHeaderMobile = ({
  disablePromoRibbon = false,
  forcePromoRibbonVisible = false,
  forceMobileHeader = false,
}: ClubHeaderMobileProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { headerContent } = use(ClubCmsContent);
  const { pageLevel, buildType, language } = use(SiteContext);

  const promoRibbonContent = useHeaderPromoRibbonContent();

  const buttonSettings = (
    button: Queries.RedesignButton | undefined
  ): HeaderButtonProps | undefined => {
    return button
      ? {
          type: 'link',
          buttonProps: button,
          handleClick: () => {
            setIsMobileMenuOpen(false);
            void amplitudeLinkTrackEvent({
              buildType,
              language,
              linkPath: button?.buttonLink,
              linkName: button?.buttonText,
              componentName: 'Club Mobile Header',
              pageLevel,
              linkEventName: 'Link in Navigation',
              linkTitle: pathToTitle(button?.buttonLink || ''),
            });
          },
        }
      : undefined;
  };

  return (
    <HeaderMobile
      headerContent={headerContent}
      primaryButton={buttonSettings(headerContent?.headerButtonPrimary)}
      secondaryButton={buttonSettings(headerContent?.headerButtonSecondary)}
      isMenuOpen={isMobileMenuOpen}
      setMenuOpen={setIsMobileMenuOpen}
      forceMobileHeader={forceMobileHeader}
      ribbonChildren={
        !disablePromoRibbon &&
        promoRibbonContent && (
          <PromoRibbon
            promoRibbon={promoRibbonContent}
            isMobile
            isMobileNavOpen={isMobileMenuOpen}
            forceVisible={forcePromoRibbonVisible}
          />
        )
      }
    />
  );
};

export default ClubHeaderMobile;
